import React, { useRef, useState } from "react";

import "./editPieceStepAddButton.css";
import XIcon from "../../../../../assets/icons/xIcon";
import UploadIcon from "../../../../../assets/icons/uploadIcon";

interface EditPieceStepAddButtonProps {
    children: any;
    onClick: () => void;
    onDrop?: (files: File[]) => void;
}

export default function EditPieceStepAddButton(props: EditPieceStepAddButtonProps) {

        const [drag, setDrag] = useState(false);
    
        const timeout = useRef<NodeJS.Timeout | undefined>(undefined);
    
        function onDragOver(e: React.DragEvent<HTMLDivElement>) {
            if(!props.onDrop) return;
            setDrag(true);
            clearTimeout(timeout.current);
            timeout.current = setTimeout(() => {
                setDrag(false);
            }, 100);
            e.preventDefault();
        }

    return <div onDrop={(event) => {
        event.preventDefault();
        var files: File[] = [];
        Array.from(event.dataTransfer.items).forEach((item, i) => {
            if (item.kind === "file") {
              const file = item.getAsFile();
              if(file != null) {
                files.push(file);
              }
            }
          });
        if(files.length > 0) {
            props.onDrop && props.onDrop(files);
        }
    }} onDragOver={onDragOver} onClick={props.onClick} className={"edit-piece-add" + (drag ? " drag" : "")}>
        <XIcon rotate={45}/>
        {props.children}
        <div className="drag-and-drop-overlay">
            <UploadIcon/>
            <p>Drop File to Upload</p>
        </div>
    </div>
}